import { MealSwapFilterOption } from "@/clients/models/MealSwapFilterOption";
import { PillButton } from "@/components/ui/buttons/PillButton";
import { memo } from "react";
import { getSubFilterIcon } from "../../utils/get-lifestyle-icon";

interface SubFilterButtonsProps {
  /**
   * List of available sub-filter options
   */
  options: MealSwapFilterOption[];
  /**
   * Currently selected sub-filter value
   */
  selectedValue?: string;
  /**
   * Callback when a sub-filter is selected
   */
  onSelect: (value: string) => void;
}

/**
 * Renders a horizontally scrollable list of sub-filter pill buttons
 * with a fade-out gradient on the right edge
 */
export const SubFilterButtons = memo(function SubFilterButtons({
  options,
  selectedValue,
  onSelect,
}: SubFilterButtonsProps) {
  return (
    <div className="relative">
      <div className="no-scrollbar flex items-center gap-2 overflow-x-auto">
        {options.map((option) => {
          const isActive = option.value === selectedValue;
          const icon = getSubFilterIcon(
            option.value,
            isActive ? "h-4 w-4 fill-white" : "h-4 w-4 fill-black",
          );
          return (
            <PillButton
              key={option.value}
              selected={isActive}
              onClick={() => onSelect(option.value)}
              className="flex w-fit items-center gap-2"
            >
              {icon}
              <span className="whitespace-nowrap">{option.name}</span>
            </PillButton>
          );
        })}
      </div>
      <div className="pointer-events-none absolute top-0 -right-1 h-full w-10 bg-gradient-to-l from-white to-transparent" />
    </div>
  );
});
